import { Flex, Text } from "@chakra-ui/react";
import ExposureLimit from "pages/Company/ExposureLimit";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useEffect, useState } from "react";
import BankAccountBalance from "../BankAccountBalance";

import TableTabs from "../TableTabs";
import UnreadMessages from "../UnreadMessages";
import WidgetBox from "../WidgetBox/widget-box";
import YourTeam from "../YourTeam";
import QuickLink from "./QuickLink";
import { checkDisability, newLoanAppPermission } from "utils/permissionHelper";
import { checkUiConfiguration } from "utils/uiconfighelper";
import LoansTable from "../LoansTable";

const BorrowerDashboard = () => {
  const { user } = useTenant();
  const [tabs, setTabs] = useState<any[]>([]);

  useEffect(() => {
    setTabs(
      user.lender_company.statuses.filter((status: any) => status.isDraft || status.isFunded)
    );
  }, []);

  return (
    <>
      <Flex gap={4}>
        <Flex direction="column" flex={1} gap={4}>
          <WidgetBox title="Loans">
            {tabs.length > 0 && (
              <TableTabs
                tabs={
                  [
                    // "All",
                    // ...tabs.map((tab) => tab.label)
                  ]
                }
                panels={[<LoansTable status={[]} small />]}
                mb="0px"
              />
            )}
          </WidgetBox>

          <UnreadMessages />
        </Flex>
        <Flex direction="column" gap={4}>
          <WidgetBox title="Quick Links">
            <Flex direction="column" gap={2}>
              {newLoanAppPermission(user) === true && (
                <QuickLink title="New Loan" to="/loans/application" />
              )}
              <QuickLink title="Documents" to="/documents" />
              {checkUiConfiguration(user, "payoff_request_enabled", false) && (
                <QuickLink title="Payoff Request" to="" />
              )}
              {checkUiConfiguration(user, "draw_request_enabled", false) && (
                <QuickLink title="Draw Request" to="" />
              )}
            </Flex>
          </WidgetBox>

          {checkUiConfiguration(user, "exposure_limit_enabled", false) && (
            <ExposureLimit company={user.company} />
          )}

          {!checkDisability(user, "disable_payment_section") && (
            <WidgetBox title="Payments">
              <Text>No upcoming payments at this time.</Text>
            </WidgetBox>
          )}

          {checkUiConfiguration(user, "bank_accounts_enabled", false) && <BankAccountBalance />}

          <YourTeam />
        </Flex>
      </Flex>
    </>
  );
};

export default BorrowerDashboard;
